<template class="">
  <Button :label="label" class="ms-2 p-button-info p-button-sm Footer savebtoon" @click="$emit('savebtn')"
    :tabindex="tabindex" :loading="loading">
    <span class="label">{{ label }}<span class="sublabel ms-2" v-if="sublabel">{{ sublabel }}</span></span>
  </Button>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
// import "bootstrap/dist/css/bootstrap.css";
export default defineComponent({
  props: {
    label: {
      type: String,
      default: "Save"
    },
    tabindex: {
      type: Number,
    },
    loading: {
      type: Boolean,
      default: false
    },
    sublabel: {
      type: String,
      default: ""
    }
  },
  setup() {
    return {};
  },
});
</script>
<style lang="scss">
@import '../../assets/variables.scss';

.savebtoon {
  background-color: $AddButton !important;
  border: none !important;
  padding: 0.5rem 0.65rem 0.5rem 0.65rem !important;
  font-size: 14px !important;
  white-space: nowrap;
  border-radius: 8px !important;

  i {
    font-size: 12px;
  }

  img {
    width: 13px;
    margin-right: 5px;
  }

  .label {
    font-weight: 500;
  }

  .sublabel {
    font-size: 9px !important;
    font-weight: 400;
  }
}
</style>